define(function(require, exports, module) {
    'use strict';

    var CompPointsView = require('replacers/comppoints/comppoints.view');
    var launcher = require('modules/launcher/launcher');
    var core = require('core');

    module.exports = CompPointsView.extend({

        initialize: function() {
            this.listenTo(core, 'comppoints:updated', launcher.closeGame.bind(launcher, false));
            return CompPointsView.prototype.initialize.apply(this, arguments);
        }
    });
});
